import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/button/button'
import {
  Link,
  LinkAsButton
} from '@components/sticker/my-stickers/common/add-link/add-link'
import {useTaskDescription} from '../task-description-store'

export const TopPanelButtons = observer(() => {
  const [state, store] = useTaskDescription()

  if (state.edit) {
    const onSave = () => {
      void store.saveContent()
    }

    return (
      <>
        <Button onClick={onSave}>{Lang.msg.save}</Button>
        <LinkAsButton onClick={() => store.cancelEdit(true)}>
          {Lang.msg.cancel}
        </LinkAsButton>
      </>
    )
  }

  const EditButton = state.fullscreen ? Button : Link
  return (
    <EditButton onClick={store.startEdit}>
      {Lang.msg.editDescription}
    </EditButton>
  )
})
